import { css } from '@emotion/react';

import { breakpoints, colors } from '@/styles';
import { p2r } from '@/styles/fonts';

const styles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${p2r(348)};
  background-color: ${colors.almostBlack};

  .bottomCard-container {
    display: flex;
    gap: 80px;
    justify-content: space-between;
    max-width: 100%;
    overflow: hidden;

    @media (max-width: ${breakpoints.tablet + 5}px) {
      flex-direction: column;
      gap: ${p2r(45)};
      align-items: center;
      justify-content: normal;
      padding: ${p2r(40)} 0;
    }
  }
`;

export default styles;
